<template>
    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row>
                        <Col>
                            <Form :model="formItem" :rules="ruleValidate" :label-width="85" label-position="right"
                                  :loading="loading" ref="form">
                                <FormItem :label="t.post.name" prop="name">
                                    <Input v-model="formItem.name" :maxlength="32"
                                           :placeholder="msgUtil.placeholderRequired(t.post.name)"></Input>
                                </FormItem>
                                <FormItem :label="t.post.code" prop="code">
                                    <Input v-model="formItem.code" :maxlength="32"
                                           :placeholder="msgUtil.placeholderRequired(t.post.code)"></Input>
                                </FormItem>
                                <FormItem :label="t.post.sortOrder" prop="sortOrder">
                                    <InputNumber v-model="formItem.sortOrder" :max="9999" :min="0"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.post.status" prop="status">
                                    <i-switch v-model="formItem.status" size="large" true-value="1" false-value="0">
                                        <span slot="open">{{t.post.open}}</span>
                                        <span slot="close">{{t.post.close}}</span>
                                    </i-switch>
                                </FormItem>
                                <FormItem :label="t.post.remark" prop="remark">
                                    <Input v-model="formItem.remark" :maxlength="200"
                                           :autosize="{minRows: 3,maxRows: 3}"
                                           :placeholder="msgUtil.placeholderRequired(t.post.remark)"
                                           type="textarea"></Input>
                                </FormItem>
                                <FormItem>
                                    <Button type="primary" :loading="loading" @click="handleSubmit()">
                                        {{msgUtil.message.action.submit}}
                                    </Button>
                                    <Button @click="handleReset()" style="margin-left: 8px">
                                        {{msgUtil.message.action.reset}}
                                    </Button>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>
<script>
import { add } from '@/api/post';

export default {
    name: 'organization_post_add',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            formItem: {
                name: '',
                code: '',
                status: '1',
                sortOrder: 0,
                remark: '',
            },
            ruleValidate: {
                name: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.post.name),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 32,
                        message: msgUtil.errorMaxLengthFullWidth(t.post.name, 32),
                        trigger: 'blur',
                    },
                ],
                code: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.post.code),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 32,
                        message: msgUtil.errorMaxLengthFullWidth(t.post.code, 32),
                        trigger: 'blur',
                    },
                ],
                remark: [
                    {
                        type: 'string',
                        max: 200,
                        message: msgUtil.errorMaxLengthFullWidth(t.post.remark, 200),
                        trigger: 'blur',
                    },
                ],
            },
            loading: false,
        };
    },
    methods: {
        handleSubmit() {
            this.loading = true;
            this.$Loading.start();
            this.$refs['form'].validate(async valid => {
                if (valid) {
                    this.loading = true;
                    const res = await add(this.formItem);
                    //console.log(res);
                    this.$Message.success(this.msgUtil.message.action.addSuccess);
                    this.$refs.form.resetFields();
                    this.$Loading.finish();
                } else {
                    this.$Loading.error();
                    this.$Message.error(this.msgUtil.message.action.addFail);
                }
            });
            this.loading = false;
        },
        handleReset() {
            this.$refs.form.resetFields();
            this.loading = false;
        },
    },
};
</script>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
